<label
    class="file-input-container {{containerClass}}"
    [ngClass]="{'disabled': disabled}">
    <div class="file-input-content">
        @if(files.length > 0){
        <ng-content select="[preview]"></ng-content>
        }
        @else {
        <ng-content select="[placeholder]"></ng-content>
        }
        <ng-content>
        </ng-content>
    </div>
    <input
        type="file"
        (change)="onFileChange(file)"
        #file
        class="file-input"
        [disabled]="disabled"
        [attr.multiple]="multiple"
        [attr.accept]="accept">
</label>